import { AggregationType, AggregationTypes } from '@carto/api-client'
import { MapDatasetEnriched } from 'features/builder/types'
import { MapType } from 'features/maps/types'

export type OperationListEntry = AggregationType | 'divider'

export const DefaultOperationEntries: AggregationType[] = [
  AggregationTypes.Avg,
  AggregationTypes.Count,
  AggregationTypes.Max,
  AggregationTypes.Min,
  AggregationTypes.Sum
]

export const OperationEntriesWithCustomAgg: OperationListEntry[] = [
  ...DefaultOperationEntries,
  'divider',
  AggregationTypes.Custom
]

export function isCustomAggregationExpSupported({ source }: { source: MapDatasetEnriched }) {
  return source.type !== MapType.tileset && source.type !== MapType.raster
}

export function isValidOperation({
  operation,
  operationColumn,
  operationExp,
  source,
  supportedTypes
}: {
  operation?: AggregationType
  operationColumn?: string
  operationExp?: string
  source?: MapDatasetEnriched
  supportedTypes?: string[]
}) {
  if (!operation) return false
  if (operation === AggregationTypes.Count) return true
  if (operation === AggregationTypes.Custom) {
    if (source && !isCustomAggregationExpSupported({ source })) return false
    if (!operationExp) return false
    return true
  }

  if (!operationColumn) return false
  if (source?.fields) {
    const field = source?.fields.find((f) => f.id === operationColumn)
    if (!field) return false

    if (supportedTypes && !supportedTypes.includes(field.type)) return false
  }

  return true
}

export function sourceHasType(source: MapDatasetEnriched, requestedType: string | string[]) {
  return source.fields?.some((field) =>
    Array.isArray(requestedType) ? requestedType.includes(field.type) : requestedType === field.type
  )
}
